import { TaskOffice } from "@/src/api/tasksPageRequests";
import { IFiltersList } from "@/src/types/applicationOnline";

export { mapTaskListItemToTableRow, getTaskListItemId } from "@/src/utils/tasks/mapTaskListItemToTableRow";

/** Row shape for Tasks table (API `id` is exposed as `task_id`). */
export interface ITasksTableRow {
  task_id: number;
  student_id: number;
  created_date: string;
  full_name: string;
  assignee_id: number;
  assignee_email: string;
  executor_id: number;
  executor_email: string;
  whoose?: string;
  type: string;
  intake: string;
  admission_semester: string;
  form_of_education: string;
  level_education: string;
  course: string;
  category: string;
  medium_of_instruction: string;
  duration: string;
  transfer_fee: string;
  certification_equalization: string;
  preparatory_department: string;
  priority: string;
  note: string;
  deadline_date: string;
  status: string;
  office: TaskOffice | string;
  form_office: string;
  office_url?: string;
  date_of_birth: string;
  student_status: string;
  attached_file: string | null;
  fullname_nat: string;
  nationality: string;
  selected_course: string;
  tuition_fee: string;
  medical_insurance: string;
  residence_permit: string;
  other_expenses: string;
  acommodation: string;
  admission_fee: string;
  complete_one_year: string;
  color_star: string;
  is_read: boolean;
}

export interface ITasksTablePayload {
  data: ITasksTableRow[];
  count_form: number;
  filters_list: IFiltersList;
}

export const getTasksTableRowId = (row: { task_id: number }): number => row.task_id;
